import { useState } from "react";
import { Autocomplete, MenuItem, Stack } from "@mui/material";

import TextField from "./text-field";
import { MenuItemProps, MenuPaperProps } from "../../Components/Form Fields/select-field";

import useDebounce from "../../CustomHooks/useDebounce";
import useAddressAutocomplete from "../../CustomHooks/useAddressAutocomplete";

import { Pin } from "../../Assets/Icons";

export default function AddressAutoCompleteField({ fieldProps = {}, onAddressSelect }) {
  const [openSuggestionMenu, setOpenSuggestionMenu] = useState(false);

  const { onChange, value = "", ...textFieldProps } = fieldProps;

  const debouncedAddress = useDebounce(value, 300);

  const { suggestions, selectPlace } = useAddressAutocomplete(debouncedAddress, onAddressSelect);

  return (
    <Autocomplete
      open={openSuggestionMenu && (suggestions?.length ?? 0) > 0}
      onOpen={() => setOpenSuggestionMenu(true)}
      onClose={() => setOpenSuggestionMenu(false)}
      inputValue={value}
      onInputChange={(event, newInputValue) => {
        if (typeof onChange === "function") {
          onChange(event?.target != null ? event : { target: { value: newInputValue } });
        }
      }}
      renderInput={(params) => (
        <>
          <input name="address" autoComplete="address" className="d-none" />
          <TextField {...params} autoComplete="none" {...textFieldProps} />
        </>
      )}
      renderOption={(props, option, { selected }) => (
        <MenuItem
          {...props}
          key={option.place_id}
          selected={selected}
          sx={{ ...MenuItemProps.sx, "&.MuiAutocomplete-option": { padding: "16px 12px" } }}
        >
          <Stack display="flex" flexDirection="row" alignItems="flex-start" gap="10px">
            <Pin />
            <Stack className="text-sm-medium" display="flex" gap="4px">
              <div>{option.structured_formatting.main_text}</div>
              <div>{option.structured_formatting.secondary_text}</div>
            </Stack>
          </Stack>
        </MenuItem>
      )}
      getOptionLabel={(option) =>
        typeof option === "string" ? option : option.structured_formatting?.main_text || option.description || ""
      }
      isOptionEqualToValue={(option, selectedValue) =>
        option?.description === selectedValue?.description
      }
      options={suggestions ?? []}
      onChange={(_, suggestion) => selectPlace(suggestion.place_id)}
      slotProps={{ paper: MenuPaperProps }}
      freeSolo
      forcePopupIcon={false}
      disableClearable
    />
  );
}
